import { Navigate, useRoutes } from 'react-router-dom'
import { LoadingScreen } from '@src/components/loading-screen'
import { Suspense, lazy } from 'react'
import { Outlet } from 'react-router'
import AuthWrapper from '@src/components/auth-wrapper'
const ResetPassword = lazy(() => import('@src/pages/reset-password'))

const HomePage = lazy(() => import('@src/pages/starter-agents'))
const MyAgents = lazy(() => import('@src/pages/my-agents/my-agent-list'))
const AgentDetail = lazy(() => import('@src/pages/my-agents/agent-detail'))
const SelectAgentType = lazy(() => import('@src/pages/my-agents/selete-agent-type'))
const CreateAgent = lazy(() => import('@src/pages/my-agents/agent-create'))
const Referral = lazy(() => import('@src/pages/referral'))
const Blog = lazy(() => import('@src/pages/blog/blog'))
const BlogDetail = lazy(() => import('@src/pages/blog/detail'))
const LandingPage = lazy(() => import('@src/pages/landing-page'))
const KOLManagement = lazy(() => import('@src/pages/kol-management'))
const TermsOfService = lazy(() => import('@src/pages/terms-of-service'))
const PrivacyPolicy = lazy(() => import('@src/pages/privacy-policy'))

const MainLayout = lazy(() => import('@src/layouts/main'))
const NotFoundPage = lazy(() => import('@src/pages/404'))
const LoginCallback = lazy(() => import('@src/pages/login-callback'))

export default function Router() {
  return useRoutes([
    {
      path: '/',
      element: (
        <MainLayout>
          <Suspense fallback={<LoadingScreen />}>
            <Outlet />
          </Suspense>
        </MainLayout>
      ),

      children: [
        {
          path: '',
          element: <LandingPage />,
        },
        {
          path: 'starter-agents',
          element: <HomePage />,
        },
        {
          path: 'my-agents',
          element: (
            <AuthWrapper path='/my-agents'>
              <MyAgents />
            </AuthWrapper>
          ),
        },
        {
          path: 'agent-detail',
          element: (
            <AuthWrapper path='/agent-detail'>
              <AgentDetail />
            </AuthWrapper>
          ),
        },
        {
          path: 'kol-management',
          element: (
            <AuthWrapper path='/kol-management'>
              <KOLManagement />
            </AuthWrapper>
          ),
        },
        {
          path: 'create-agent',
          element: (
            <AuthWrapper path='/create-agent'>
              <CreateAgent />
            </AuthWrapper>
          ),
        },
        {
          path: 'agent-type',
          element: (
            <AuthWrapper path='/agent-type'>
              <SelectAgentType />
            </AuthWrapper>
          ),
        },
        {
          path: 'referral',
          element: (
            <AuthWrapper path='/referral'>
              <Referral />
            </AuthWrapper>
          ),
        },

        { path: 'help-center', element: <Blog /> },
        { path: 'blog-detail/:title', element: <BlogDetail /> },
        { path: 'terms-of-service', element: <TermsOfService /> },
        { path: 'privacy-policy', element: <PrivacyPolicy /> },

        { path: 'login-callback', element: <LoginCallback /> },
        { path: 'reset-password', element: <ResetPassword /> },
      ],
    },

    { path: '404', element: <NotFoundPage /> },
    { path: '*', element: <Navigate to='/404' replace /> },
  ])
}
